<div class="fulfillmentLanding container-return-wrapper associate-crop-landing">
  <div class="containerReturnsLandingPage">
    <div class="row plotSeedHeader">
      <div class="col-12 mb-3">
        <h3>
          Plot Seed Release Inquiry
        </h3>
      </div>
    </div>

    <div class="row plotSeedFilterSection">
      <div class="col-lg-11 col-md-9 pr-0">
        <app-filter [(optionsData)]="filterOptionsData" [isSearchButtonOutside]="true" (exportClick)="export()" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>
      </div>
      <div>
        <button mat-raised-button class="btns xs-button xs-full-width exportBtn" [disabled]="(plotSeedDataSource && plotSeedDataSource.data.length == 0)" (click)="export()">Export</button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 legend-outer">
        <div class="d-flex justify-content-end btnWrap">
          <button mat-raised-button class="btns newOrderBtn" color="primary" (click)="reviewRelease()">Review Release</button>  &nbsp;&nbsp;
          <button *ngIf="editFullAccess"  mat-raised-button class="btns newOrderBtn" color="primary" (click)="createNewRelease()">Create New Release</button>
        </div>
        <mat-tab-group class="matTabs prepayLandingTab">
          <mat-tab>
            <ng-template mat-tab-label>
              <i class="icon-ico-dealer_icon padding-t10 xs-mr-5" aria-hidden="true"></i>
              <div class="tab-head">
                <h4>
                  Plot Seed Orders
                </h4>
                <p class="subhead">
                  View Your Plot Seed Orders
                </p>
              </div>
            </ng-template>
            <div class="fulfill-top-sec">
              <div class="row listing-action-items">
                <div class="col-12">
                  <div class="d-flex justify-content-end">
                    <!--<input type="checkbox" id="chkRemQty" /> <label> Display Line with Remaining Qty > 0</label>-->
                    <span class="checkDisplay">
                      <mat-checkbox [(ngModel)]="remainingQtyChk" (change)="getGridData(false)" class="custom-checkbox margin-l10" data-testid="chk-plot-seed-rem"></mat-checkbox> Display Line with Remaining Qty > 0
                    </span>
                    <mat-paginator #plotSeedPaginator [pageSize]="masterConstants.PAGE_SIZE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
                  </div>
                </div>
              </div>
            </div>
            <div class="tableContainer activeReturnRequest">
              <table mat-table #plotSeedTable [dataSource]="plotSeedDataSource" matSort #plotSeedSort matSortDirection="desc" class="matTables containerDrafTable">
                <ng-container matColumnDef="orderHeaderID">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Order Number</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    <div class="order-info handCursor" (click)="navigateOrderDetail(element)">
                      <u>
                        <p class="accNo">
                          {{element.webOrderNumber}}
                        </p>
                      </u>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="salesManagerAccountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center">Sales Manager Account</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.salesManagerAccountNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="salesManagerAccountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Sales Manager Name</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    <div class="order-info">
                      <p class="accName">
                        {{element.salesManagerAccountName}}
                      </p>
                      <!--<p class="accName">{{element.shipToCity}}, {{element.shipToState}}</p>-->
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="shipToAccount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center">Account Number</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.accountNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="accountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Account Name</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    <div class="order-info">
                      <p class="accName">
                        {{element.accountName}}
                      </p>
                      <!--<p class="accName">{{element.shipToCity}}, {{element.shipToState}}</p>-->
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="parentAccountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center">Parent Account Number</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.parentAccountNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="parentName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Parent Name</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    <div class="order-info">
                      <p class="accName">
                        {{element.parentName}}
                      </p>
                      <!--<p class="accName">{{element.shipToCity}}, {{element.shipToState}}</p>-->
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="productLine">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Product Line</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center">
                    <div class="order-info">
                      <p class="accName">
                        {{element.productLine}}
                      </p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="brand">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-center">Hybrid Variety</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.hybridVariety}} </td>
                </ng-container>
                <ng-container matColumnDef="marketingBrand">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-center">Marketing Brand</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.marketingBrand}} </td>
                </ng-container>
                <ng-container matColumnDef="maturity">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Maturity</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.maturity }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="orderDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate  text-center">Order Date</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderDate | date:'MM/dd/yyyy'}} </td>
                </ng-container>
                <ng-container matColumnDef="orderQty">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Ordered Qty</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderQty | number:'1.0-0'}} </td>
                </ng-container>
                <ng-container matColumnDef="releasedQty">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Released Qty</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.releasedQty | number:'1.0-0'}} </td>
                </ng-container>
                <ng-container matColumnDef="remQty">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Remaining Qty</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.remainingQty | number:'1.0-0'}} </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Status</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.status}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="plotSeedOrderColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let row; columns: plotSeedOrderColumns;"></tr>
              </table>
              <div *ngIf="plotSeedDataSource == undefined || (plotSeedDataSource && plotSeedDataSource.data.length == 0)" class="noDataMsg">
                <p class="padding-b47">No Record Found.</p>
              </div>
            </div>
          </mat-tab>

        </mat-tab-group>
      </div>
    </div>
  </div>
</div>

